import { DataTableBuilderComponent } from '@/components/data-table-builder/data-table-builder.component';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { MeetingRepository } from '@/store/meeting-state/meeting-state.repository';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { getPresenceDataTableStructure } from './utils/presence-data-table-object';
import { MeetingRoleEnum, Participant } from '@/types/meeting.types';

@Component({
  selector: 'sm-presence-data-table',
  imports: [DataTableBuilderComponent, CommonModule],
  templateUrl: './presence-data-table.component.html',
  styleUrl: './presence-data-table.component.scss',
})
export class PresenceDataTableComponent implements OnInit {
  meetingRepository = inject(MeetingRepository);

  @Input() createAction?: () => void;
  @Input() disabled = false;

  dataTableObject: DynamicDataTable = getPresenceDataTableStructure({
    onSwitchChange: this.disabled ? undefined : (row: Participant, value: boolean) => this.onSwitchChange(row, value),
    onSwitchChangePresidency: this.disabled ? undefined : (row: Participant, value: boolean) => this.onSwitchChangePresidency(row, value),
    createAction: this.disabled ? undefined : () => this.createAction?.(),
  });

  loading = false;

  data: Participant[] = [];

  ngOnInit(): void {
    if (this.disabled) {
      this.dataTableObject = getPresenceDataTableStructure({
        onSwitchChange: undefined,
        createAction: undefined,
        onSwitchChangePresidency: undefined,
        presentation: true,
      });
    }
    this.meetingRepository.getNestedObservable<any[]>('dto', 'participants').subscribe(participants => {
      this.data = participants;
    });
  }

  onSwitchChange(row: Participant, value: boolean) {
    row.present = value;
    this.data = this.data.map(p => (p.id === row.id ? { ...p, present: value } : p));

    const committeePresident = this.data.find(p => p.fonction === MeetingRoleEnum.PRESIDENT);
    if (committeePresident?.present) {
      this.data = this.data.map(p => ({
        ...p,
        fonctionReunion: p.id === committeePresident.id ? MeetingRoleEnum.PRESIDENT : MeetingRoleEnum.MEMBER,
      }));
    } else {
      const currentPresident = this.data.find(p => p.fonctionReunion === MeetingRoleEnum.PRESIDENT);
      if (currentPresident && !currentPresident.present) {
        this.data = this.data.map(p => ({ ...p, fonctionReunion: MeetingRoleEnum.MEMBER }));
      }
    }
    this.meetingRepository.setNested('dto', 'participants', this.data);
    this.meetingRepository.clearError('participants');
  }

  onSwitchChangePresidency(row: Participant, value: boolean) {
    this.data = this.data.map(p => ({
      ...p,
      present: p.fonction === MeetingRoleEnum.PRESIDENT ? false : p.present,
    }));
    if (value) {
      this.data = this.data.map(p => ({
        ...p,
        fonctionReunion: p.id === row.id ? MeetingRoleEnum.PRESIDENT : MeetingRoleEnum.MEMBER,
        present: p.id === row.id ? true : p.present,
      }));
    } else {
      this.data = this.data.map(p => ({
        ...p,
        fonctionReunion: p.id === row.id ? MeetingRoleEnum.MEMBER : p.fonctionReunion,
      }));
    }
    this.meetingRepository.setNested('dto', 'participants', this.data);
    this.meetingRepository.clearError('participants');
  }
}
